export default __webpack_public_path__ + "static/media/guide09.cbef9b77.png";